import { formatMoney } from '../../lib/formatters.ts'
import type { ProjectTableRow } from '../../api/cashReport'
import CrIcon from './CrIcon.tsx'

type SortKey = 'expected_in_cents' | 'expected_out_cents' | 'open_balance_cents' | 'project_name'

type Props = {
  rows: ProjectTableRow[]
  sortKey: SortKey
  onSort: (key: SortKey) => void
  onOpen: (projectId: number) => void
}

function moneyBtn(
  cents: number | undefined,
  formatted: string | undefined,
  onClick: () => void,
  testId: string,
) {
  const label = formatted || formatMoney((cents || 0) / 100)
  return (
    <button type="button" className="cr-amount-link" data-testid={testId} onClick={onClick}>
      {label}
    </button>
  )
}

export default function ProjectsTable({ rows, sortKey, onSort, onOpen }: Props) {
  return (
    <section className="cr-section" data-testid="cr-projects">
      <div className="cr-section-label">
        <span>Projects behind the numbers</span>
        <span>Sorted by expected in</span>
      </div>
      <div className="cr-table-scroll">
        <table className="cr-table cr-project-table">
          <thead>
            <tr>
              <th>
                <button type="button" onClick={() => onSort('project_name')}>Project</button>
              </th>
              <th>
                <button type="button" onClick={() => onSort('expected_in_cents')} aria-sort={sortKey === 'expected_in_cents' ? 'descending' : undefined}>
                  Expected in
                </button>
              </th>
              <th>
                <button type="button" onClick={() => onSort('expected_out_cents')}>Expected out</button>
              </th>
              <th>
                <button type="button" onClick={() => onSort('open_balance_cents')}>Open balance</button>
              </th>
              <th>Next risk</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.project_id} data-testid={`cr-project-${row.project_id}`}>
                <td className="cr-project-name">
                  <button type="button" className="cr-project-link" onClick={() => onOpen(row.project_id)}>
                    {row.project_name}
                  </button>
                  <small>#{row.project_id}</small>
                  {row.inflow_note ? <small className="cr-inflow-note">{row.inflow_note}</small> : null}
                </td>
                <td>{moneyBtn(row.expected_in_cents, row.expected_in?.formatted, () => onOpen(row.project_id), `cr-project-${row.project_id}-in`)}</td>
                <td>{moneyBtn(row.expected_out_cents, row.expected_out?.formatted, () => onOpen(row.project_id), `cr-project-${row.project_id}-out`)}</td>
                <td>{moneyBtn(row.open_balance_cents, row.open_balance?.formatted, () => onOpen(row.project_id), `cr-project-${row.project_id}-bal`)}</td>
                <td className={row.next_risk && row.next_risk !== 'Normal' ? 'cr-risk' : undefined}>
                  <span className="cr-risk-word">
                    <CrIcon name={row.next_risk === 'Late' ? 'customer-late' : row.next_risk === 'Watch' ? 'customer-watch' : 'customer-normal'} />
                    {row.next_risk || 'Normal'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}
